import axios from "axios";

import { Vue} from 'vue-property-decorator';
// 引入下载组件
import fileDownload from 'js-file-download';

import { Loading } from 'element-ui';

export function download(url: any, data: any) {
  let param = {
    ...data,
  }
  const fileName = param.fileName;

  axios({
    url: '/api/' + url,
    data: param,
    method: 'post',
    responseType: 'blob',
  }).then((res: any) => {
      if (res.data.size > 0) {
        const options = {"text":"下载中"};
        let loadingInstance1 = Loading.service({ fullscreen: true });
        // 使用下载组件下载附件
        fileDownload(res.data, fileName);
        loadingInstance1.close();
      }else{
        
      }
  })
}
